import parallaxScroller from "./_parallaxScroller.script.js";

parallaxScroller.init();
